import { PropertyTypeEnum } from '@app/enums/property-type.enum';

export class Property {
    showInputOnTypes: { [key: string]: string[] } = {
        'address.street': [
            PropertyTypeEnum.flatPrivate,
            PropertyTypeEnum.flatCooperative,
            PropertyTypeEnum.familyHouse,
            PropertyTypeEnum.recreationalObject,
            PropertyTypeEnum.apartmentBuilding,
            PropertyTypeEnum.other,
        ],
        'address.registryNumber': [
            PropertyTypeEnum.flatPrivate,
            PropertyTypeEnum.flatCooperative,
            PropertyTypeEnum.familyHouse,
            PropertyTypeEnum.recreationalObject,
            PropertyTypeEnum.apartmentBuilding,
            PropertyTypeEnum.other,
        ],
        'address.houseNumber': [
            PropertyTypeEnum.flatPrivate,
            PropertyTypeEnum.flatCooperative,
            PropertyTypeEnum.familyHouse,
            PropertyTypeEnum.recreationalObject,
            PropertyTypeEnum.apartmentBuilding,
            PropertyTypeEnum.other,
        ],
        'address.orientationNumber': [
            PropertyTypeEnum.flatPrivate,
            PropertyTypeEnum.flatCooperative,
            PropertyTypeEnum.familyHouse,
            PropertyTypeEnum.recreationalObject,
            PropertyTypeEnum.apartmentBuilding,
            PropertyTypeEnum.other,
        ],
        'address.parcelNumber': [PropertyTypeEnum.land],
        'address.unitNumber': [PropertyTypeEnum.flatPrivate, PropertyTypeEnum.flatCooperative],
        isDeveloperProject: [PropertyTypeEnum.flatPrivate, PropertyTypeEnum.familyHouse],
        housingUnitsCount: [PropertyTypeEnum.apartmentBuilding],
        commercialAreaPercentage: [PropertyTypeEnum.apartmentBuilding],
        cadastreRegisterSeparately: [PropertyTypeEnum.apartmentBuilding],
    };

    requiredOnTypes: { [key: string]: string[] } = {
        'address.street': [
            PropertyTypeEnum.flatPrivate,
            PropertyTypeEnum.flatCooperative,
            PropertyTypeEnum.familyHouse,
            PropertyTypeEnum.apartmentBuilding,
        ],
        'address.houseNumber': [
            PropertyTypeEnum.flatPrivate,
            PropertyTypeEnum.flatCooperative,
            PropertyTypeEnum.familyHouse,
            PropertyTypeEnum.apartmentBuilding,
        ],
        'address.cadastralTerritory': [PropertyTypeEnum.land],
    };
}
